import { AvailableSeatsData } from '@3ddv/igsu-models/definitions/seat.model';
import { SectionModel, SectionResponseModel } from '@3ddv/igsu-models/definitions/section.model';
import { EventModel } from '@3ddv/utils-igsu';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TicketModel } from 'projects/common/igsu-models/definitions/ticket.model';

@Injectable({ providedIn: 'root' })
export class SectionsAPI {
  private http = inject(HttpClient);

  public fetchSectionAvailability = (
    eventID: EventModel['id'],
    selectedTickets?: TicketModel[] | null
  ): Observable<SectionResponseModel> => {
    let params = new HttpParams();
    if (selectedTickets && selectedTickets.length > 0) {
      const ticketsForFiltering = selectedTickets.map(ticket => ({
        id: ticket.id,
        buyerType: ticket.buyerType,
        price: ticket.price.value,
      }));
      params = params.set('selectedTickets', JSON.stringify(ticketsForFiltering));
    }
    return this.http.get<SectionResponseModel>(`/events/${eventID}/availability`, { params });
  };

  public fetchSeatAvailavility = (
    eventID: EventModel['id'],
    sectionID: SectionModel['sectionID'],
    selectedTickets?: TicketModel[] | null
  ) => {
    let params = new HttpParams();
    if (selectedTickets && selectedTickets.length > 0) {
      const ticketsForFiltering = selectedTickets.map(ticket => ({
        id: ticket.id,
        buyerType: ticket.buyerType,
        price: ticket.price.value,
      }));
      params = params.set('selectedTickets', JSON.stringify(ticketsForFiltering));
    }
    return this.http.get<AvailableSeatsData & { rawAvailableSeats: string[]; reference: any }>(
      `/events/${eventID}/sections/${sectionID}/availability`,
      { params }
    );
  };
}
